// extracted by mini-css-extract-plugin
module.exports = {"visuals":"ProductVisuals_visuals__3gWXL","price":"ProductVisuals_price__3MGYn"};